// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3Vs6I","tab":"Tabs_tab__26T0v","tabActive":"Tabs_tabActive__2p-NX"};